import MasterConfigurations from './MasterConfigurations';

export default MasterConfigurations;
